/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import { ThemeTokens } from '../types';

export const defaultTheme: ThemeTokens = {
  colors: {
    primary: '#2563eb',
    secondary: '#10b981',
    background: '#f9fafb',
    surface: '#ffffff',
    text: '#111827',
    mutedText: '#6b7280',
    border: '#e5e7eb',
    accent: '#f59e0b',
    danger: '#ef4444'
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
  },
  radius: {
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16
  },
  typography: {
    fontFamily: 'Inter, system-ui, sans-serif',
    headingWeight: 700,
    bodyWeight: 400
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
  }
};
